import { render, staticRenderFns } from "./CustomerBonusesModal.vue?vue&type=template&id=a811bbc2&scoped=true"
import script from "./CustomerBonusesModal.vue?vue&type=script&lang=js"
export * from "./CustomerBonusesModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerBonusesModal.vue?vue&type=style&index=0&id=a811bbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a811bbc2",
  null
  
)

export default component.exports